import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { fadeAnimation } from 'src/animations';
import { NotificationTask } from 'src/app/classes';
import { MailService } from 'src/app/lib/mail/services/mail.service';
import { IIssueProviderService, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { ISSUE_FORM_GROUP } from '../issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-send-mail-dialog',
  templateUrl: './send-mail-dialog.component.html',
  styleUrls: ['./send-mail-dialog.component.css'],
  providers: [
    {
      provide: ISSUE_FORM_GROUP, deps: [ISSUE_PROVIDER_SERVICE], useFactory: (service: IIssueProviderService) => {
        return service.formGroup.controls['issue'];
      }
    }
  ],
  animations: [ fadeAnimation ]
})
export class SendMailDialogComponent implements OnInit {

  formGroup: FormGroup;

  private _sending  = new BehaviorSubject(false);
  sending$ = this._sending.asObservable();

  constructor(
    @Inject(ISSUE_PROVIDER_SERVICE) public service: IIssueProviderService,
    private _ref: MatDialogRef<SendMailDialogComponent>,
    private _formBuilder: FormBuilder,
    private _mailService: MailService,
    private _snackBar: MatSnackBar
  ) {
    this.formGroup = this._formBuilder.group({
      'notifications': this._formBuilder.array([])
    });
  }

  close = () => this._ref.close(false);

  ngOnInit(): void {

  }

  sendMails() {
    if(this._sending.value) return;
    let tasks = this.formGroup.controls['notifications'].value as NotificationTask[];
    if(tasks.some(x => x.receiver.length === 0)){
      this._snackBar.open(`Mindestens eine Nachricht hat keinen Empfänger! Jede E-Mail braucht mindestens eine valide E-Mail-Adresse.`, 'Ok', {
        duration: 5000
      });
      return;
    }
    this.service.issueId$.pipe(
      take(1),
      switchMap((issueId: number) => combineLatest((this.formGroup.controls['notifications'].value as NotificationTask[])
        .filter(x => x.receiver)
        .map(x => {
          this._sending.next(true);
          x.issueId = issueId;
          return this._mailService.sendMail(x, x.receiver);
        })))
    ).subscribe({
      complete: () => {
        this._sending.next(false);
        this._ref.close(true);
      }
    });
  }

}
